import React from 'react';

import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import LockboxDividedRecords from './LockboxDividedRecords';
import LockboxDividingModeForm from './LockboxDividingModeForm';

const LockboxDividingMode = () => {
  const { isDividingMode, originalLockbox } = useLockboxDetailsStore();

  if (originalLockbox?.lockboxStatus === LockboxStatus.DIVIDED) {
    return <LockboxDividedRecords />;
  }

  if (isDividingMode) {
    return <LockboxDividingModeForm />;
  }

  return null;
};

export default LockboxDividingMode;
